// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as _ from "lodash";
import colors from '../../../assets/css/colors';
import {
	PlayerRowMenuStyled,
	PlayerRowMenuButton,
	PlayerRowMenuCloseButton,
} from '../../../components';
import Close from '../../../components/Icons/Close';
import V from '../../../components/Icons/V';
import T from '../../../components/Icons/T';
import S from '../../../components/Icons/S';
import D from '../../../components/Icons/D';
import C from '../../../components/Icons/C';
import E from '../../../components/Icons/E';
import Stop from '../../../components/Icons/Stop';

const PlayerRowMenuButtonRelative = styled(PlayerRowMenuButton)`
	flex-direction: column;
	span {
		font-size: 8px;
		letter-spacing: 0.36px;
		line-height: 1.375;
		font-weight: bold;
		margin-top: 4px;
	}
`;

type Props = {
	id: number,
	handleCaptain: Function,
	handleViceCaptain: Function,
	handleSubstitute: Function,
	handleEmergency: Function,
	addOutTrade: Function,
	onClose: Function,
	captains: boolean,
	is_bench: boolean,
	is_emergency_enabled: boolean,
	positions: Array<number>,
	positions_by_id: Object,
	position_in_lineup: number,
	is_captain: boolean,
	is_vice_captain: boolean,
	is_emergency: boolean,
	emergency_position: number,
	is_management_available: boolean,
	round_status: string,
	rounds: Array<Object>
};

type State = {
	is_double_check: boolean
};

export class PlayerRowMenuTeam extends React.Component<Props, State> {
	state = {
		is_double_check: false,
	};

	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'getDPPItem'
		]);
	}

	// eslint-disable-next-line complexity
	get leaders() {
		const {
			id, captains,
			is_bench,
			handleCaptain,
			handleViceCaptain,
			is_captain,
			is_vice_captain,
			is_management_available,
			round_status
		} = this.props;

		if (!captains || is_bench) {
			return null;
		}
		return (
			<React.Fragment>
				<PlayerRowMenuButton onClick={() => handleCaptain(id)}
					background={is_captain ? colors.captain : '#fff'}
					is_shadow={!is_captain}
					disabled={is_management_available === false}
				>
					{(!is_management_available || round_status !== 'scheduled')?
						<Stop color={is_captain ? '#fff' : colors.captain} size="2" />:
						<C color={is_captain ? '#fff' : colors.captain} />
					}
				</PlayerRowMenuButton>
				<PlayerRowMenuButton onClick={() => handleViceCaptain(id)}
					background={is_vice_captain ? colors.vice_captain : '#fff'}
					is_shadow={!is_vice_captain}
					disabled={is_management_available === false}
				>
					{(!is_management_available || round_status !== 'scheduled')?
						<Stop color={is_vice_captain ? '#fff' : colors.vice_captain} size="2" />:
						<V color={is_vice_captain ? '#fff' : colors.vice_captain} />
					}
				</PlayerRowMenuButton>
			</React.Fragment>
		);
	}

	get emergency() {
		const {
			handleEmergency,
			positions,
			is_emergency_enabled,
			id: player_id,
			is_emergency,
			is_management_available
		} = this.props;

		if (!is_emergency_enabled) {
			return null;
		}
		const is_dpp = _.size(positions) > 1;

		return is_dpp ? (
			<React.Fragment>
				{ positions.map(this.getDPPItem) }
			</React.Fragment>
		) : (
			<PlayerRowMenuButtonRelative
				onClick={() => handleEmergency({ player_id, position: positions[0] })}
				background={is_emergency ? colors.emergency_active : '#fff'}
				is_shadow={!is_emergency}
				color={is_emergency ? '#fff' : colors.emergency_active}
				disabled={is_emergency && !is_management_available}
			>
				{!is_management_available? <Stop size="2" />: <E /> }
			</PlayerRowMenuButtonRelative>
		);
	}

	get trade_buttons() {
		const { id, addOutTrade, is_management_available } = this.props;
		
		return (
			<React.Fragment>
				<PlayerRowMenuButton
					onClick={() => addOutTrade({ id, is_fa: false })}
					background="#fff"
					is_shadow
					disabled={is_management_available === false}
					color="#0B1C17"
				>
					{is_management_available? <T /> : <Stop size="2" />}
				</PlayerRowMenuButton>

				<PlayerRowMenuButton
					onClick={() => addOutTrade(
						{ id, is_fa: true }
					)}
					border={colors.negative_value}
					disabled={is_management_available === false}
					color={colors.negative_value}
				>
					{is_management_available? <D /> : <Stop size="2" />}
				</PlayerRowMenuButton>
			</React.Fragment>
		);
	}

	getDPPItem(position: number) {
		const {
			handleEmergency,
			positions_by_id,
			id: player_id,
			is_emergency,
			emergency_position,
			is_management_available
		} = this.props;
		const is_active_emergency = is_emergency && emergency_position === position,
			color = is_active_emergency ? '#fff' : colors.emergency_active;
		return (
			<PlayerRowMenuButtonRelative
				key={position}
				onClick={() => handleEmergency({ player_id, position })}
				background={is_active_emergency ? colors.emergency_active : '#fff'}
				color={color}
				is_shadow={!is_active_emergency}
				disabled={is_management_available === false}
			>
				{is_management_available? <E color={color} />: <Stop size="2" />}
				<span>
					{positions_by_id[position].short_name}
				</span>
			</PlayerRowMenuButtonRelative>
		);
	}

	render() {
		const {
			id,
			handleSubstitute,
			onClose,
			is_bench,
			positions,
			position_in_lineup,
			is_management_available,
			rounds
		} = this.props;
		const substitute_object = {
			id,
			is_bench,
			positions,
			position_in_lineup
		};
		const isSeasonFinished = _.last(rounds).status === "complete";
		return (
			<PlayerRowMenuStyled>
				{!isSeasonFinished && this.trade_buttons}
				<PlayerRowMenuButton onClick={() => handleSubstitute(substitute_object)}
					background="#c0c0c0"
					disabled={is_management_available === false}
					color="#fff"
				>
					{is_management_available? <S /> : <Stop size="2" />}
				</PlayerRowMenuButton>
				{this.leaders}
				{this.emergency}
				<PlayerRowMenuCloseButton onClick={onClose}>
					<Close color={colors.darkGrey} />
				</PlayerRowMenuCloseButton>
			</PlayerRowMenuStyled>
		);
	}
}

export default PlayerRowMenuTeam;


// WEBPACK FOOTER //
// ./src/pages/league/team/playerRowMenuTeam.js